// @ts-check
import { Flex } from 'components/base/layout-components';
import CreateProjectDude from 'images/characters/create-project-dude.svg';
import Text from 'components/base/Text';
import { LBButton } from '@linearb/buzz';

const EmptyProjects = ({ onAddProjectClick, isCanConfigProjects }) => {
  return (
    <Flex
      items='center'
      justify='center'
      direction='column'
      width='100%'
      padding='small'
    >
      <img src={CreateProjectDude} alt='' />
      <Text size='x-x-x-large' mt='2rem' mb='1rem' weight='300'>
        Setup your first project
      </Text>
      <Flex width='50%' items='center' justify='center' direction='column'>
        <Text color='shuttleGray' size='large' mb='0.3rem'>
          Start tracking <b>Planning Accuracy</b>, <b>People Effort</b>, and the
          <b> Issue Type</b>
        </Text>
        <Text color='shuttleGray' size='large' mb='0.3rem'>
          <b>Investment</b> of your team’s most important initiatives.
        </Text>
        <Text color='shuttleGray' size='large' mb='1rem'>
          Tracking project progress is easy with LinearB!
        </Text>
        {isCanConfigProjects ? (
          <LBButton size='lg' onClick={onAddProjectClick}>
            Add a project
          </LBButton>
        ) : (
          <Text size='large' weight='bold' color='shuttleGray' pt='1rem'>
            Ask your admin to start adding projects
          </Text>
        )}
      </Flex>
    </Flex>
  );
};

export default EmptyProjects;
